import { Modal } from 'antd';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/TimeKeeperDevice/TimeKeeperDeviceModel';
import { RootState } from '../../../store';
import TimeKeeperDeviceForm from '../TimeKeeperDeviceForm/TimeKeeperDeviceForm';

const TimeKeeperDeviceModal: FC<any> = () => {
  const dispatch = useDispatch();
  const reduxTimeKeeperDevice = useSelector((state: RootState) => state.models.timeKeeperDevice);

  return (
    <Modal
      title={!!reduxTimeKeeperDevice.id ? 'Modifica' : 'Adauga'}
      open={reduxTimeKeeperDevice.props.isModalVisible}
      onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
      width={700}
      footer={null}
    >
      <TimeKeeperDeviceForm />
    </Modal>
  );
};

export default TimeKeeperDeviceModal;
